export const ACTION = {
  LOAD_PARTICIPATION_FORMS: 'LOAD_PARTICIPATION_FORMS',
  LOAD_PARTICIPATION_FORMS_COMPLETED: 'LOAD_PARTICIPATION_FORMS_COMPLETED',

  PARTICIPATION_FORM_LOAD_DRAFT: 'PARTICIPATION_FORM_LOAD_DRAFT',
  PARTICIPATION_FORM_LOAD_DRAFT_COMPLETED: 'PARTICIPATION_FORM_LOAD_DRAFT_COMPLETED',

  PARTICIPATION_FORM_AMEND: 'PARTICIPATION_FORM_AMEND',
  PARTICIPATION_FORM_AMEND_COMPLETED: 'PARTICIPATION_FORM_AMEND_COMPLETED',

  PARTICIPATION_FORM_RETURN: 'PARTICIPATION_FORM_RETURN',
  PARTICIPATION_FORM_RETURN_COMPLETED: 'PARTICIPATION_FORM_RETURN_COMPLETED',

  PARTICIPATION_FORM_SAVE: 'PARTICIPATION_FORM_SAVE',
  PARTICIPATION_FORM_SAVE_COMPLETED: 'PARTICIPATION_FORM_SAVE_COMPLETED',

  PARTICIPATION_FORM_SAVE_CLEANUP: 'PARTICIPATION_FORM_SAVE_CLEANUP',
  PARTICIPATION_FORM_SAVE_CLEANUP_COMPLETED: 'PARTICIPATION_FORM_SAVE_CLEANUP_COMPLETED',

  PARTICIPATION_FORM_GENERATE_PROGRAM: 'PARTICIPATION_FORM_GENERATE_PROGRAM',
  PARTICIPATION_FORM_GENERATE_PROGRAM_COMPLETED: 'PARTICIPATION_FORM_GENERATE_PROGRAM_COMPLETED',

  PARTICIPATION_FORM_SAVE_PROGRAM: 'PARTICIPATION_FORM_SAVE_PROGRAM',
  PARTICIPATION_FORM_SAVE_PROGRAM_COMPLETED: 'PARTICIPATION_FORM_SAVE_PROGRAM_COMPLETED',

  PARTICIPATION_FORM_APPROVE: 'PARTICIPATION_FORM_APPROVE',
  PARTICIPATION_FORM_APPROVE_COMPLETED: 'PARTICIPATION_FORM_APPROVE_COMPLETED',

  PARTICIPATION_FORM_DECLINE: 'PARTICIPATION_FORM_DECLINE',
  PARTICIPATION_FORM_DECLINE_COMPLETED: 'PARTICIPATION_FORM_DECLINE_COMPLETED',

  PARTICIPATION_FORM_ENABLE_ORDERING: 'PARTICIPATION_FORM_ENABLE_ORDERING',
  PARTICIPATION_FORM_ENABLE_ORDERING_COMPLETED: 'PARTICIPATION_FORM_ENABLE_ORDERING_COMPLETED',

  PARTICIPATION_FORM_EMAIL_SUPPLIER: 'PARTICIPATION_FORM_EMAIL_SUPPLIER',
  PARTICIPATION_FORM_EMAIL_SUPPLIER_COMPLETED: 'PARTICIPATION_FORM_EMAIL_SUPPLIER_COMPLETED',

  PARTICIPATION_FORM_INACTIVATE: 'PARTICIPATION_FORM_INACTIVATE',
  PARTICIPATION_FORM_INACTIVATE_COMPLETED: 'PARTICIPATION_FORM_INACTIVATE_COMPLETED',

  PARTICIPATION_FORM_RESTRICTED_SITE_APPROVAL: 'PARTICIPATION_FORM_RESTRICTED_SITE_APPROVAL',
  PARTICIPATION_FORM_RESTRICTED_SITE_APPROVAL_COMPLETED: 'PARTICIPATION_FORM_RESTRICTED_SITE_APPROVAL_COMPLETED',

  PARTICIPATION_FORM_INDIVIDUAL_RESTRICTED_SITE_APPROVAL: 'PARTICIPATION_FORM_INDIVIDUAL_RESTRICTED_SITE_APPROVAL',
  PARTICIPATION_FORM_INDIVIDUAL_RESTRICTED_SITE_APPROVAL_COMPLETED: 'PARTICIPATION_FORM_INDIVIDUAL_RESTRICTED_SITE_APPROVAL_COMPLETED',

  LOAD_CURRENT_USER: 'LOAD_CURRENT_USER',
  LOAD_CURRENT_USER_COMPLETED: 'LOAD_CURRENT_USER_COMPLETED',

  LOAD_FORM_CODE: 'LOAD_FORM_CODE',
  LOAD_FORM_CODE_COMPLETED: 'LOAD_FORM_CODE_COMPLETED',

  PARTICIPATION_FORM_LOAD: 'PARTICIPATION_FORM_LOAD',
  PARTICIPATION_FORM_LOAD_COMPLETED: 'PARTICIPATION_FORM_LOAD_COMPLETED',

  PARTICIPATION_FORM_LOAD_CLEANUP: 'PARTICIPATION_FORM_LOAD_CLEANUP',
  PARTICIPATION_FORM_LOAD_CLEANUP_COMPLETED: 'PARTICIPATION_FORM_LOAD_CLEANUP_COMPLETED',

  ERROR: 'ERROR'
};



// WEBPACK FOOTER //
// /home/runner/work/slipresistant/slipresistant/client/src/app/shared/constant/action.constant.ts